<template>

  <el-container  class="home-container">
    <!--头部区域  class="home-container"-->
    <el-header>
      <div>
        <img src="../assets/spc.png" alt="">
       <!-- <span>Customer Schedule Management</span> -->
      </div>
      <div>
        <span>{{loginname}}</span>
        <span></span>
        <el-button type="info" @click="changePasswordDialog">Password Change</el-button>
        <el-button type="info" @click="logout">Logout</el-button>
      </div>
      <el-dialog
         title="Change Password"
         :visible.sync="editDialogVisible"
         width="50%" @close="editDialogClosed">
         <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="200px">
           <el-form-item label="old password" prop="oldPassword" >
             <el-input v-model="editForm.oldPassword" type="password" style="width: 300px"></el-input>
           </el-form-item>
           <el-form-item label="new password" prop="newPassword" blur="passwordValidCheck">
             <el-input v-model="editForm.newPassword" type="password" style="width: 300px"></el-input>
             <!-- <el-input v-model="editForm.newPassword" @focus.capture.native='changePasswordTip(true)'
             @blur.capture.native='changePasswordTip(false)' auto-complete="new-password" type="password" placeholder='请输入密码' ></el-input>
             <div style="position: absolute">
               <verify-pass-word-tip :password="editForm.newPassword" :isShowTip = 'isShowTip'></verify-pass-word-tip>
               </div> -->
           </el-form-item>
           <el-form-item label="repeated password" prop="rePassword" blur="reppasswordCheck">
             <el-input v-model="editForm.rePassword" type="password" style="width: 300px"></el-input>
           </el-form-item>
         </el-form>
         <span slot="footer" class="dialog-footer">
           <el-button @click="editDialogVisible = false">Cancel</el-button>
           <el-button type="primary" @click="changePassword">OK</el-button>
         </span>
       </el-dialog>
    </el-header>
    <!--页面主体区域v-on:-->
    <el-container>
      <!--侧边栏-->
      <el-aside :width="isCollapse ? '64px':'200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu
              background-color="#333744"
              text-color="#fff" :collapse="isCollapse" :collapse-transition="false"
              active-text-color="#409EFF" router :default-active="activePath">
              <el-submenu index="1" v-if="this.userType!=='2'">
                <template slot="title">
                  <i class="el-icon-s-data"></i>
                  <span>Schedule</span>
                </template>
                <el-menu-item index="/schedule" @click="saveNavState('/schedule')" v-if="this.userType!=='2'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Ready Dates</span>
                </template>
                </el-menu-item>
                <!-- <el-menu-item index="/delivery" @click="saveNavState('/delivery')" v-if="this.userType!=='2' && this.username.toUpperCase()!=='SDPP'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Deliveries</span>
                </template>
                </el-menu-item> -->
                <!-- <el-menu-item index="/moq" @click="saveNavState('/moq')" v-if="this.userType!=='2' && this.username.toUpperCase()!=='SDPP'"> -->
                <el-menu-item index="/moq" @click="saveNavState('/moq')" v-if="this.username.toUpperCase()==='J3P' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT'  || this.username.toUpperCase()==='HBG' || this.username.toUpperCase()==='OMC'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>MOQ Leadtime</span>
                </template>
                </el-menu-item>
                <!-- <el-menu-item index="/readygoods" @click="saveNavState('/readygoods')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Ready Goods List</span>
                </template>
                </el-menu-item> -->
                <!-- <el-menu-item index="/rfqForwarder" @click="saveNavState('/rfqForwarder')" v-if="this.username.toUpperCase()==='SPC1010'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>RFQ Forwarder</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/rglFile" @click="saveNavState('/rglFile')" v-if="this.username.toUpperCase()==='SPC1010'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>RGL Files</span>
                </template>
                </el-menu-item> -->
                <!-- <el-menu-item index="/project" @click="saveNavState('/project')" v-if="this.username.toUpperCase()!=='SDPP'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Project Status</span>
                </template>
                </el-menu-item> -->
                <!-- <el-menu-item index="/prospectProject" @click="saveNavState('/prospectProject')" v-if="this.username.toUpperCase()!=='SDPP'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Prospect Project</span>
                </template>
                </el-menu-item> -->
                <el-menu-item index="/yach" @click="saveNavState('/yach')" v-if="this.username.toUpperCase()==='J3P'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Production Plan</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/yach4Customer" @click="saveNavState('/yach4Customer')" v-if="this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Production Plan</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/yachHistory" @click="saveNavState('/yachHistory')" v-if="this.username.toUpperCase()==='J3P'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Schedule History</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/yachUpdatesHistory" @click="saveNavState('/yachUpdatesHistory')" v-if="this.username.toUpperCase()==='J3P'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Schedule Update History</span>
                </template>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="5" v-if="this.userType==='1' || this.userType==='0'">
                <template slot="title">
                  <i class="el-icon-s-marketing"></i>
                  <span>Development</span>
                </template>
                <el-menu-item index="/project" @click="saveNavState('/project')" v-if="this.username.toUpperCase()!=='SDPP'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Project Status</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/CRProject" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT'|| this.username.toUpperCase()==='HBG'" @click="saveNavState('/CRProject')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Project</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/CRTask" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT' || this.username.toUpperCase()==='HBG'" @click="saveNavState('/CRTask')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Task/Component</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/timeline"  @click="saveNavState('/timeline')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Timeline</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/pdr"  @click="saveNavState('/pdr')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Pdr</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/qaRequest" @click="saveNavState('/qaRequest')" v-if="this.userType==='1'">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>QA Request</span>
                  </template>
                </el-menu-item>
              </el-submenu>

              <!-- <el-submenu index="9" v-if="this.username.toUpperCase()==='SPC1010'">
                <template slot="title">
                  <i class="el-icon-s-cooperation"></i>
                  <span>RFQ Forwarder</span>
                </template>
                <el-menu-item index="/rfqForwarder" @click="saveNavState('/rfqForwarder')" v-if="this.username.toUpperCase()==='SPC1010'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>File Generate</span>
                </template>
                </el-menu-item>
              </el-submenu> -->
              <!-- <el-submenu index="3" v-if="this.userType!=='2'">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>Timeline</span>
                </template>
                <el-menu-item index="/timeline" v-if="this.userType!=='2'" @click="saveNavState('/timeline')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Timeline</span>
                  </template>
                </el-menu-item>
              </el-submenu> -->

              <el-submenu index="2" v-if="this.userType==='1' || this.userType==='2'">
                <template slot="title">
                  <i class="el-icon-s-operation"></i>
                  <span>Production</span>
                </template>
                <!-- <el-menu-item index="/forwarderschedule" @click="saveNavState('/forwarderschedule')" v-if="this.userType==='1' || this.username.toUpperCase()==='IP'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>CBM by Port/Factory</span>
                </template>
                </el-menu-item> -->
                <el-menu-item index="/forwarderQtySchedule" @click="saveNavState('/forwarderQtySchedule')" v-if="this.userType==='1'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>QTY Rolling Plan</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/yach1Schedule" @click="saveNavState('/yach1Schedule')" v-if="this.userType==='1' || this.userType==='2'">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Loading Schedule</span>
                  </template>
                  </el-menu-item>
                  <el-menu-item index="/yachPOSchedule" @click="saveNavState('/yachPOSchedule')" v-if="this.userType==='1'">
                      <template slot="title">
                      <i class="el-icon-location"></i>
                      <span>PO Schedule</span>
                    </template>
                    </el-menu-item>
                  <!-- <el-menu-item index="/inputSchedule" @click="saveNavState('/inputSchedule')" v-if="this.userType==='1'">
                      <template slot="title">
                      <i class="el-icon-location"></i>
                      <span>PO Schedule</span>
                    </template>
                    </el-menu-item> -->
                    <el-menu-item index="/exportSchedule" @click="saveNavState('/exportSchedule')" v-if="this.userType==='1' || this.userType==='2'">
                        <template slot="title">
                        <i class="el-icon-location"></i>
                        <span>Factory Schedule</span>
                      </template>
                      </el-menu-item>
                      <el-menu-item index="/followUp" @click="saveNavState('/followUp')" v-if="this.userType==='1'">
                        <template slot="title">
                          <i class="el-icon-location"></i>
                          <span>Output</span>
                        </template>
                      </el-menu-item>
                      <el-menu-item index="/output" @click="saveNavState('/output')" v-if="this.userType==='1' || this.userType==='2'">
                                            <template slot="title">
                                              <i class="el-icon-location"></i>
                                              <span>Output(M/W/D)</span>
                                            </template>
                                          </el-menu-item>
              <!-- <el-menu-item index="/moq" @click="saveNavState('/moq')" v-if="this.userType!=='2'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>MOQ Leadtime List</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/readygoods" @click="saveNavState('/readygoods')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Ready Goods List</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/project" @click="saveNavState('/project')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Project Status</span>
                </template>
                </el-menu-item> -->
              </el-submenu>

              <el-submenu index="6" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT' || this.username.toUpperCase()==='HBG'">
                <template slot="title">
                  <i class="el-icon-s-goods"></i>
                  <span>Logistics</span>
                </template>
                <el-menu-item index="/readygoods" @click="saveNavState('/readygoods')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Ready Goods List</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/delivery" @click="saveNavState('/delivery')" v-if="this.userType!=='2' && this.username.toUpperCase()!=='SDPP'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Deliveries</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/forwarderschedule" @click="saveNavState('/forwarderschedule')" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT' || this.username.toUpperCase()==='HBG'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>CBM by Port</span>
                </template>
                </el-menu-item>
                <!-- <el-menu-item index="/forwarderschedule4IPIT" @click="saveNavState('/forwarderschedule4IPIT')" v-if="this.username.toUpperCase()==='IPIT' || this.username.toUpperCase()==='HBG'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>CBM by Port</span>
                </template>
                </el-menu-item> -->
                <el-menu-item index="/yach1CBMSchedule" @click="saveNavState('/yach1CBMSchedule')" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT' || this.username.toUpperCase()==='HBG'">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>CBM by Brand</span>
                  </template>
                  </el-menu-item>
                  <el-menu-item index="/rfqForwarder" @click="saveNavState('/rfqForwarder')" v-if="this.username.toUpperCase()==='J3P'">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Cargo Creation</span>
                  </template>
                  </el-menu-item>
                  <!-- <el-menu-item index="/rglFileManage" @click="saveNavState('/rglFileManage')" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT' || this.username.toUpperCase()==='HBG'"> -->
                  <el-menu-item index="/rglFileManage" @click="saveNavState('/rglFileManage')" v-if="this.userType==='1' || this.username.toUpperCase()==='IP' || this.username.toUpperCase()==='IPIT'">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Cargo Management</span>
                  </template>
                  </el-menu-item>
              </el-submenu>

              <el-submenu index="8" v-if="this.userType==='1'">
                <template slot="title">
                  <i class="el-icon-s-custom"></i>
                  <span>Opportunity</span>
                </template>
                <el-menu-item index="/prospectCRProject" @click="saveNavState('/prospectCRProject')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Project</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/prospectCRTask" @click="saveNavState('/prospectCRTask')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Task/Component</span>
                </template>
                </el-menu-item>
                <el-menu-item index="/prospectTimeline" @click="saveNavState('/prospectTimeline')">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Timeline</span>
                  </template>
                  </el-menu-item>
                  <el-menu-item index="/prospectProject" @click="saveNavState('/prospectProject')">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Project Status</span>
                  </template>
                  </el-menu-item>
              </el-submenu>

          <el-submenu index="9" v-if="this.userType==='1'">
            <template slot="title">
              <i class="el-icon-s-check"></i>
              <span>Quality(beta)</span>
            </template>
            <el-menu-item index="/qualityCategory" @click="saveNavState('/qualityCategory')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>Quality Category</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/qaTestRequest" @click="saveNavState('/qaTestRequest')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>QA Test Request</span>
              </template>
            </el-menu-item>
            <!-- <el-menu-item index="/qcSchedule" @click="saveNavState('/qcSchedule')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>QA Request</span>
              </template>
            </el-menu-item> -->
            <!-- <el-menu-item index="/qaReport" @click="saveNavState('/qaReport')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>QA Report</span>
              </template>
            </el-menu-item> -->
            <el-menu-item index="/qcReport" @click="saveNavState('/qcReport')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>QC Report</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- <el-submenu index="10" v-if="this.userType==='1' || this.username.toUpperCase()==='IP'">
            <template slot="title">
              <i class="el-icon-office-building"></i>
              <span>Factory</span>
            </template>
            <el-menu-item index="/subItem" @click="saveNavState('/subItem')" v-if="this.userType==='1' || this.userType==='2'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>Sub Item</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/factory" @click="saveNavState('/factory')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>Factory</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/followUp" @click="saveNavState('/followUp')" v-if="this.userType==='1' || this.userType==='2'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>Output</span>
              </template>
            </el-menu-item>
          </el-submenu> -->
              <el-submenu index="7" v-if="this.userType==='1' || this.username.toUpperCase()==='IP'">
                <template slot="title">
                  <i class="el-icon-s-claim"></i>
                  <span>Setup</span>
                </template>
                <el-menu-item index="/customer" @click="saveNavState('/customer')" v-if="this.userType==='1'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Business Partner</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/brand" @click="saveNavState('/brand')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Brand</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/customerContact" @click="saveNavState('customerContact')" v-if="this.userType==='1'">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>User</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/systemRole" @click="saveNavState('systemRole')" v-if="this.userType==='1'">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>System Role</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/supplier" @click="saveNavState('supplier')" v-if="this.userType==='1'">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Supplier</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/supplierQC" @click="saveNavState('supplierQC')" v-if="this.userType==='1' && (this.loginname.toUpperCase()==='SPC_ADMIN' || this.loginname.toUpperCase()==='DHG')">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>SupplierQC</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/subItem" @click="saveNavState('/subItem')" v-if="this.userType==='1'">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Sub Item</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/factory" @click="saveNavState('/factory')" v-if="this.userType==='1'">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Factory</span>
                  </template>
                </el-menu-item>
                <!-- <el-menu-item index="/followUp" @click="saveNavState('/followUp')" v-if="this.userType==='1'">
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>Output</span>
                  </template>
                </el-menu-item> -->

              </el-submenu>

    <!--      <el-submenu index="10" v-if="this.userType==='1' || this.username.toUpperCase()==='IP'">
            <template slot="title">
              <i class="el-icon-s-claim"></i>
              <span>System Management</span>
            </template>
            <el-menu-item index="/userManagement" @click="saveNavState('/userManagement')" v-if="this.userType==='1'">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>User Management</span>
              </template>
            </el-menu-item>
          </el-submenu>-->

              <!--<el-submenu index="4" v-if="this.userType=='0'">
                <template slot="title">
                  <i class="el-icon-s-shop"></i>
                  <span>Quotation</span>
                </template>
                <el-menu-item index="/initQuote" @click="saveNavState('/initQuote')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Initiate quotation</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/todotask" @click="saveNavState('/todotask')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>To do tasks</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/taskdone" @click="saveNavState('/taskdone')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Tasks done</span>
                  </template>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="4" v-if="this.userType=='1'">
                <template slot="title">
                  <i class="el-icon-s-shop"></i>
                  <span>Quotation</span>
                </template>
                <el-menu-item index="/initQuote" @click="saveNavState('/initQuote')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Initiate quotation</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/todotask" @click="saveNavState('/todotask')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>To do tasks</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/taskdone" @click="saveNavState('/taskdone')">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>Tasks done</span>
                  </template>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="5" v-if="this.userType=='2'">
                <template slot="title">
                  <i class="el-icon-s-shop"></i>
                  <span>Quotation2</span>
                </template>
                <el-submenu index="1-4">
                  <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>To do tasks</span>
                  </template>
                  <el-menu-item index="/quotationView" @click="saveNavState('/quotationView')">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>FQ View</span>
                    </template>
                  </el-menu-item>
                  <el-menu-item index="/quotation" @click="saveNavState('/FqRecall')">
                    <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>FQ Recall</span>
                    </template>
                  </el-menu-item>
                </el-submenu>
              </el-submenu> -->
            </el-menu>
      </el-aside>
      <!--右侧内容主体-->
      <el-main>
        <!--路由占位符-->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>

</template>

<script>
// import onBeforeRouteUpdate from 'vue-router'

// import passwordValid from 'formValidation'
// import verifyPassWordTip from '../tool/VerifyPassWordTip.vue'
export default {
  // name: 'VerifyPassWord',
  // components: {
  //   verifyPassWordTip
  // },
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again!'))
      } else if (value !== this.editForm.newPassword) {
        callback(new Error('Please input the same password as the new password!'))
      } else {
        callback()
      }
    }

    return {
      permissions: [],
      isCollapse: false,
      activePath: '',
      username: '',
      loginname: '',
      userType: '',
      editDialogVisible: false,
      editForm: {
        oldPassword: '',
        newPassword: '',
        username: '',
        password: ''
      },
      // editpwd: {
      //   username: this.username,
      //   password: this.editForm.newPassword
      // },
      // password: '',
      // isShowTip: false,
      editFormRules: {
        oldPassword: [
          { required: true, message: 'Please input password', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: 'Please input new password', trigger: 'blur' },
          { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/, message: 'The password should include 3 kinds of the numbers,lowercase letters,capital letters,special letters at least. The length is between 8 and 30.' }
          // { validator: checkPassword, trigger: 'blur' }
        ],
        rePassword: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
    this.loginname = window.sessionStorage.getItem('loginname')
    this.username = window.sessionStorage.getItem('username')
    this.userType = window.sessionStorage.getItem('userType')
    this.getPermissionsByUser(this.loginname.toUpperCase())
  },
  watch: {
    $route (to, from) {
      // console.log(to)
      this.activePath = to.path
      // console.log(from)
    }
  },
  // 路由监听
  // onBeforeRouteUpdate (to, from, next) {
  //   this.activePath = to.path
  // },
  methods: {
    async getPermissionsByUser (x) {
      this.permissions = []
      const { data: res } = await this.$http.get('/systemRole/getPermissionsByUser' + '?user=' + x)
      const nlist = []
      for (let i = 0; i < res.length; i++) {
        nlist.push(res[i].name)
      }
      this.permission = nlist
      console.log(this.permission)
      // if (this.permission.includes('userAdd')) { this.userAdd = 1 }
    },
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    changePasswordTip (isShow) {
      if (isShow) {
        this.isShowTip = true
      } else {
        this.isShowTip = false
      }
    },
    async changePassword () {
      this.editForm.password = this.editForm.oldPassword
      this.editForm.username = this.loginname
      const { data: res } = await this.$http.post('userManagement/login', this.editForm)
      // if (res.code !== 200) return this.$message.error('Logon failor')
      // const { data: res } = await this.$http.post('user/login?username=' + this.username + '&password=' + this.editForm.oldPassword)
      // const { data: res } = await this.$http.post('user/getUserInfo', { params: this.editForm })

      if (res.code !== 200) return this.$message.error('Input Old password incorrectly')
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('user/changepwd', this.editForm)
        if (res.code !== '200') {
          return this.$message.error('Changing password failor!')
        }
        // close dialog
        // prompt changing successfullly
        this.editDialogVisible = false
        this.$message.success('Changing password successfully!')
      })
      // this.editForm.username = this.username
    },
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    changePasswordDialog () {
      this.editDialogVisible = true
    },
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    passwordValidCheck () {
      // var flag=passwordValid(passWord);
      // var password = this.editForm.newPassword
      // alert('password===' + password)
      // var flag = passwordValid(passWord)
      // var flag = this.oldPassword
      // console.log(flag)
      // this.$message.error(flag)
    },
    // passwordValid (pass) {
    //   // var passLower = pass.toLocaleLowerCase()
    //   var flag = ' '
    //   if (pass === null || pass.length < 8 || pass.length > 20 || pass.length === '') {
    //   // $.messager.alert("错误","密码位数不对，长度最少8位，最大20位。");
    //     flag = '密码位数不对，长度最少8位，最大20位'
    //     return flag
    //   }
    //   // 判断是否默认密码
    //   // if (isDefaultPass(userName, pass))
    //   // {
    //   // return "密码为默认密码或弱口令"
    //   // }
    //   // 是数字
    //   // var isDigit = /^.*[0-9]+.*/
    //   // // isLowerCase 小写字母
    //   // var isLowerCase = /^.*[a-z]+.*/
    //   // // isUpperCase 大写字母
    //   // var isUpperCase = /^.*[A-Z]+.*/
    //   // // 特殊字符
    //   // var regEx = /^.*[^a-zA-Z0-9]+.*/
    //   // // 记录匹配的次数
    //   // var num = 0
    //   // if (isDigit.test(pass)) {
    //   //   num = num + 1
    //   // }
    //   // if (isLowerCase.test(pass)) {
    //   //   num = num + 1
    //   // }
    //   // if (isUpperCase.test(pass)) {
    //   //   num = num + 1
    //   // }
    //   // if (regEx.test(pass)) {
    //   //   num = num + 1
    //   // }
    //   // if (num <= 2) {
    //   //   // $.messager.alert("错误","密码复杂度不足,\n(1)大写字母\n(2)小写字母\n(3)数字\n(4)特殊符号\n密码至少需包含上述情形中的三种.");
    //   //   flag = '密码复杂度不足,\n(1)大写字母\n(2)小写字母\n(3)数字\n(4)特殊符号\n密码至少需包含上述情形中的三种'
    //   //   return flag
    //   // }
    // },
    reppasswordCheck () {
      // var passWord = this.newPassword
      // var flag = this.repPassword
      if (this.newPassword !== this.repPassword) {
        this.$message.error('Please input the same password as the new password')
      }
      // console.log(flag)
    }
  }
}
</script>
<style lang="less" scoped="scoped">
.home-container {
  height: 100%;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  // align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}

.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
    .el-submenu {
      margin-left:-15px
    }
  }
}

.el-main {
  background-color: #eaedf1;
}

.icon-font {
  margin-right:10px
}

.toggle-button {
  background-color:#4A5064;
  font-size:10px;
  line_height:24px;
  color:#fff;
  text-align:center;
  letter-spacing:0.2em;
  cursor:pointer;
}

</style>
